// generated from 8_622 samples

import { z } from "zod";
import { common } from "../common";

export const interactedWithCampaignTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::InteractedWithCampaign"),
  // null: 4 (0.05%)
  interaction: z.string().nullable(),
  // undefined: 7_209 (83.61%), defined 1_413 (16.39%)
  link_click_data: z
    .object({
      // undefined: 641 (45.36%), defined 772 (54.64%)
      // null: 14 (1.81%)
      global_alias: z.string().nullable().optional(),
      // undefined: 772 (54.64%), defined 641 (45.36%)
      link_data: z
        .object({
          campaign_id: common.objectId,
          display_value: z.string(),
          link_id: common.objectId,
        })
        .optional(),
    })
    .optional(),
  // null: 983 (11.40%)
  selected_campaign_id: common.objectId.nullable(),
  // null: 983 (11.40%)
  selected_campaign_name: z.string().nullable().optional(),
  // null: 8_616 (99.93%)
  selected_carousel_slide_id: common.objectId.nullable().optional(),
  // null: 8_616 (99.93%)
  selected_carousel_slide_name: z.string().nullable().optional(),
  // null: 8_599 (99.73%)
  selected_push_button_name: z.string().nullable().optional(),
  // null: 8_599 (99.73%)
  selected_push_button_string: z.string().nullable().optional(),
});
